import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to) {
    if (to.hash == '#main-footer'){
      return
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      alias: '/fr',
      name: 'Home',
      meta:{
        frPath: '/fr',
        enPath: '/',
      },
      component: () => import(/* webpackChunkName: "Home" */'./pages/Home.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.home.length === 0) {
          store.dispatch('loadHome').then(next)
        } else {
          next()
        }
      },
    },
    {
      path: '/work/:id',
      alias: '/fr/realisations/:id',
      name: 'Project',
      meta:{
        frPath: '/fr/realisations',
        enPath: '/work',
      },
      component: () => import(/* webpackChunkName: "Project" */'./pages/Project.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('loadProject', to.params.id).then(next)
      },
    },
    {
      path: '/projects/:id',
      redirect: { path: '/work/:id' },
    },
     {
      path: '/fr/projects/:id',
      redirect: { path: 'fr/realisations/:id' },
    },
    {
      path: '/work',
      alias: '/fr/realisations',
      name: 'ProjectsPage',
      meta:{
        frPath: '/fr/realisations',
        enPath: '/work',
      },
      component: () => import(/* webpackChunkName: "ProjectsPage" */'./pages/ProjectsPage.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.projectsPage.length === 0) {
          store.dispatch('loadProjectsPage').then(next);
        }else{
          next()
        }
        if (store.state.projects.length === 0) {
          store.dispatch('loadProjects').then(next);
        }else{
          next()
        }
      },
    },
    {
      path: '/clients',
      alias: '/fr/clients',
      name: 'Clients',
      meta:{
        frPath: '/fr/clients',
        enPath: '/clients',
      },
      component: () => import(/* webpackChunkName: "Clients" */'./pages/Clients.vue'),
    },
    {
      path: '/legal-notices',
      alias: '/fr/mentions-legales',
      name: 'Legal',
      meta:{
        frPath: '/fr/mentions-legales',
        enPath: '/legal-notices',
      },
      component: () => import(/* webpackChunkName: "Default" */'./pages/Default.vue')
    },
    {
      path: '/about-us',
      alias: '/fr/a-propos',
      name: 'About',
      meta:{
        frPath: '/fr/a-propos',
        enPath: '/about-us',
      },
      component: () => import(/* webpackChunkName: "About" */'./pages/About.vue')
    },
    {
      path: '/contact',
      alias:'/fr/contact',
      name: 'Contact',
      meta:{
        frPath: '/fr/contact',
        enPath: '/contact',
      },
      component: () => import(/* webpackChunkName: "Contact" */'./pages/Contact.vue')
    },
    {
      path: '/en/404',
       alias:'/fr/404/',
      name: 'Not Found',
      meta:{
        frPath: '/fr/404',
        enPath: '/404',
      },
      component: () => import(/* webpackChunkName: "Contact" */'./pages/NotFound.vue')
    },
    {
      path: '/fr/*',
      redirect: '/fr/404'
    },
    {
      path: '/*',
      redirect: '/404'
    }
  ],
})

router.beforeEach((to, from, next) => {
  let splitPath = to.path.split('/');
  if(splitPath.length && splitPath[1] === 'fr'){
    to.meta.lang = 'fr'
  }else{
    to.meta.lang = 'en'
  }
  next();
})

export default router;



